import { render } from "./Badge.vue?vue&type=template&id=3f01d112"
import script from "./Badge.vue?vue&type=script&lang=js"
export * from "./Badge.vue?vue&type=script&lang=js"
script.render = render

export default script